import {
  FormControl,
  FormHelperText,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import PWDKDialog from 'components/PWDKDialog';
import PWDKOutlinedInput from 'components/PWDKOutlinedInput';
import PWDKLoadingButton from 'components/new/PWDKLoadingButton';
import { Formik } from 'formik';
import useSearchQuery from 'hooks/useSearchQuery';
import { useSnackbar } from 'notistack';
import React from 'react';
import axiosInstance from 'utils/axios';
import * as Yup from 'yup';

const RejectModal = ({ open, onClose, refetch, tribeMemberData }) => {
  const { id, email } = tribeMemberData || {};
  const { tribeId } = useSearchQuery();
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('md'));
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Formik
      initialValues={{ reason: '' }}
      validationSchema={Yup.object().shape({
        reason: Yup.string().required().label('Rejection Reason'),
      })}
      onSubmit={async (values) => {
        try {
          const response = await axiosInstance.delete(
            '/v2/tribe-member/decline-member/tribe-leader',
            {
              params: {
                tribeMemberId: id,
                tribeId: Number(tribeId),
                email,
              },
              data: {
                reason: values.reason,
              },
            },
          );
          if (response) {
            refetch();
            enqueueSnackbar('User has been successfuly rejected', {
              variant: 'default',
            });
          }
        } catch (error) {
          enqueueSnackbar(error.message, { variant: 'error' });
        }
      }}
    >
      {({
        getFieldProps,
        errors,
        values,
        touched,
        handleSubmit,
        resetForm,
        isSubmitting,
      }) => (
        <PWDKDialog
          open={open}
          onClose={() => {
            onClose();
            resetForm();
          }}
          title="Reject Member Request"
          subtitle="Please provide a reason"
          paperPropsStyle={{ maxWidth: '552px' }}
          fullWidth
          dialogActions={
            <PWDKLoadingButton
              size={isMobile ? 'medium' : 'large'}
              variant="primary"
              onClick={handleSubmit}
              loading={isSubmitting}
            >
              Submit
            </PWDKLoadingButton>
          }
        >
          <FormControl fullWidth error={errors.reason && touched.reason}>
            <PWDKOutlinedInput
              {...getFieldProps('reason')}
              rows={8}
              multiline
              placeholder="Write down reason of rejection"
              helperText={touched.reason && errors.reason}
              inputProps={{ maxLength: 500 }}
            />
            <Stack direction="row" justifyContent="space-between">
              {errors.reason && touched.reason && (
                <FormHelperText>{errors.reason}</FormHelperText>
              )}
              <Typography
                ml="auto"
                mt={{ md: 1, xs: 0.5 }}
                typography={{ md: 'paragraph2', xs: 'captionRegular' }}
                color="neutral400.main"
              >
                {values.reason.length}/500 Character
              </Typography>
            </Stack>
          </FormControl>
        </PWDKDialog>
      )}
    </Formik>
  );
};

export default RejectModal;
